



























    import { Component, Watch } from "../../../Infrastructure/CorBase/CoreBase";
	import SettingListBase from "./SettingListBase";

	@Component
	export default class SettingTenantList extends SettingListBase {

		queryBase2: any;
		private goBackPage(): void {
			this.goBackPageBase();
		}


		descriptionName() {	
            return this.$t('setting.descriptionTenant');
		}

        private showDetail():boolean {
            return this.allowEditBase();
        }

		created() {
			this.isTenantSetting = true;
            this.paramGoBack="SettingTenantList"
		//	this.setIsGlobalSetting();
			this.initializeRightsLocal();
            this.createdBase();
			super.setAlertModalId('alertModalSettingList');
			super.created();
			super.setDetailName('SettingDetail');
            this.idSettingGroup = String(this.$route.query['idSettingGroup']);
            this.loadDefault(this.idSettingGroup);

		}


		loadFilters(value: any) { super.loadFilters(value); };
		detailClick(elementId: any) { super.detailClick(elementId); };



	};
